// sessionManager.js
class SessionManager {
  constructor(baseUrl = '') {
    this.baseUrl = baseUrl;
    this.frontendUid = this.getOrCreateFrontendUid();
    this.backendToken = sessionStorage.getItem('backendToken') || null;
    this.initialized = !!this.backendToken;
  }
  getOrCreateFrontendUid() {
    const stored = localStorage.getItem('frontendUid');
    if (stored) return stored;
    const newUid = crypto.randomUUID?.() || Math.random().toString(36).substring(2, 15);
    localStorage.setItem('frontendUid', newUid);
    return newUid;
  }
  getUrl(path) {
    return `${this.baseUrl}${path}`;
  }
  async _fetch(endpoint, options = {}) {
    try {
      const response = await fetch(this.getUrl(endpoint), {
        headers: { 'Content-Type': 'application/json' },
        ...options
      });
      const data = await response.json();
      if (!response.ok) {
        return {
          success: false,
          error: data.error || `HTTP error ${response.status}`
        };
      }
      return data; // Backend already returns {success: true/false, ...}
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Network error'
      };
    }
  }
  // Clears any stale backend session state so a fresh one can be created.
  // Does not touch frontendUid — that identity persists across sessions.
  resetSession() {
    this.backendToken = null;
    this.initialized = false;
    sessionStorage.removeItem('backendToken');
  }
  async init() {
    if (this.initialized) return { success: true };
    const result = await this._fetch('/maritime/session/init/', {
      method: 'POST',
      body: JSON.stringify({ frontend_uid: this.frontendUid })
    });
    if (result.success) {
      this.backendToken = result.backend_token;
      sessionStorage.setItem('backendToken', this.backendToken);
      this.initialized = true;
    }
    return result;
  }
  async logAnalytics(extraData = {}) {
    if (!this.initialized) {
      const initResult = await this.init();
      if (!initResult.success) return initResult;
    }
    if (!this.backendToken) {
      return { success: false, error: 'Session not initialized' };
    }
    return this._fetch('/maritime/analytics/', {
      method: 'POST',
      body: JSON.stringify({
        frontend_uid: this.frontendUid,
        backend_token: this.backendToken,
        path: window.location.pathname,
        ...extraData
      })
    });
  }
  async submitContact(formData) {
    if (!this.initialized) {
      const initResult = await this.init();
      if (!initResult.success) return initResult;
    }
    if (!this.backendToken) {
      return { success: false, error: 'Session not initialized' };
    }
    return this._fetch('/maritime/contact/', {
      method: 'POST',
      body: JSON.stringify({
        ...formData,
        frontend_uid: this.frontendUid,
        backend_token: this.backendToken
      })
    });
  }
}


// Usage: Set baseUrl once when creating the instance
export const sessionManager = new SessionManager('https://h2explorer.com/api/');